import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Badge } from "@/components/ui/badge";

const ACTION_LABELS = {
  "user.create": ["Mitarbeiter angelegt", "bg-sky-50 text-sky-800 border-sky-200"],
  "user.update": ["Mitarbeiter aktualisiert", "bg-slate-50 text-slate-700 border-slate-200"],
  "user.delete": ["Mitarbeiter deaktiviert", "bg-red-50 text-red-700 border-red-200"],
  "vacation.create": ["Urlaubsantrag", "bg-sky-50 text-sky-800 border-sky-200"],
  "vacation.approved": ["Urlaub genehmigt", "bg-emerald-50 text-emerald-800 border-emerald-200"],
  "vacation.rejected": ["Urlaub abgelehnt", "bg-red-50 text-red-700 border-red-200"],
  "vacation.delete": ["Urlaub gelöscht", "bg-slate-50 text-slate-700 border-slate-200"],
  "document.upload": ["Dokument hochgeladen", "bg-teal-50 text-teal-800 border-teal-200"],
  "document.download": ["Dokument geladen", "bg-slate-50 text-slate-700 border-slate-200"],
  "document.delete": ["Dokument gelöscht", "bg-red-50 text-red-700 border-red-200"],
  "todo.create": ["Aufgabe erstellt", "bg-sky-50 text-sky-800 border-sky-200"],
  "todo.update": ["Aufgabe aktualisiert", "bg-slate-50 text-slate-700 border-slate-200"],
  "todo.delete": ["Aufgabe gelöscht", "bg-red-50 text-red-700 border-red-200"],
};

export default function AuditLog() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/audit-log").then(({ data }) => setItems(data)).catch(() => {});
  }, []);
  return (
    <div className="space-y-6">
      <div>
        <p className="ph-label">Compliance</p>
        <h1 className="font-display text-3xl font-semibold tracking-tight mt-1">Audit-Log</h1>
        <p className="text-slate-500 text-sm mt-1">Vollständige Historie aller wichtigen Aktionen (DSGVO).</p>
      </div>
      <div className="ph-card overflow-hidden">
        <div className="hidden md:grid grid-cols-12 px-5 py-3 text-[11px] uppercase tracking-wider font-semibold text-slate-500 border-b border-slate-200 bg-slate-50/50">
          <div className="col-span-3">Zeitpunkt</div>
          <div className="col-span-3">Akteur</div>
          <div className="col-span-3">Aktion</div>
          <div className="col-span-3">Details</div>
        </div>
        <ul className="divide-y divide-slate-100">
          {items.map((i) => {
            const meta = ACTION_LABELS[i.action] || [i.action, "bg-slate-50 text-slate-600 border-slate-200"];
            return (
              <li key={i.id} className="grid grid-cols-1 md:grid-cols-12 px-5 py-3 gap-1">
                <div className="md:col-span-3 text-xs text-slate-500 tabular-nums">
                  {new Date(i.created_at).toLocaleString("de-DE")}
                </div>
                <div className="md:col-span-3 text-sm text-slate-800">{i.actor_name}</div>
                <div className="md:col-span-3">
                  <Badge variant="outline" className={`text-[10px] uppercase ${meta[1]}`}>{meta[0]}</Badge>
                </div>
                <div className="md:col-span-3 text-xs text-slate-500 truncate">
                  {Object.keys(i.details || {}).length > 0 ? JSON.stringify(i.details) : "—"}
                </div>
              </li>
            );
          })}
          {items.length === 0 && <li className="text-center text-sm text-slate-400 py-10">Noch keine Einträge.</li>}
        </ul>
      </div>
    </div>
  );
}
